"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _cuid = _interopRequireDefault(require("cuid"));
var HorizontalThreeDots = function HorizontalThreeDots(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    uniqueId: uniqueId
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20 10C20 11.3142 18.9342 12.38 17.62 12.38C16.3058 12.38 15.24 11.3142 15.24 10C15.24 8.68583 16.3058 7.62 17.62 7.62C18.9342 7.62 20 8.68583 20 10ZM10 7.62C8.68583 7.62 7.62 8.68583 7.62 10C7.62 11.3142 8.68583 12.38 10 12.38C11.3142 12.38 12.38 11.3142 12.38 10C12.38 8.68583 11.3142 7.62 10 7.62ZM2.38 7.62C1.06583 7.62 0 8.68583 0 10C0 11.3142 1.06583 12.38 2.38 12.38C3.69417 12.38 4.76 11.3142 4.76 10C4.76 8.68583 3.69417 7.62 2.38 7.62Z"
  }));
};
var _default = exports["default"] = HorizontalThreeDots;